import * as React from 'react';

import { darken } from 'polished';
import styled, { css } from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import SocialIcon from '@components/basics/social-icon';

export type SignupCompany = 'facebook' | 'twitter' | 'google' | 'apple';

export interface SignupProps {
  company?: SignupCompany;
  children?: any;
  className?: string;
  onClick: (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const SignupSocial: React.FC<SignupProps> = (props) => (
  <Flex
    className={props.className}
    onClick={(ev: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
      props.onClick(ev)
    }
  >
    <Typography weight="700" className="label">
      {props.children}
    </Typography>
    <SocialIcon className="icon" company={props.company} />
  </Flex>
);

export default styled(SignupSocial)`
  padding: 30px;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  height: 94px;
  width: 100%;
  flex-grow: 1;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  @media ${({ theme }) => theme.device.tablet} {
    height: 134px;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
  }

  ${(props) =>
    props.company === 'facebook'
      ? css`
          background-color: ${({ theme }) => theme.colors.facebook};
          &:hover {
            background-color: ${({ theme }) =>
              darken(0.05, theme.colors.facebook)};
          }
        `
      : null};
  ${(props) =>
    props.company === 'twitter'
      ? css`
          background-color: ${({ theme }) => theme.colors.twitter};
          &:hover {
            background-color: ${({ theme }) =>
              darken(0.05, theme.colors.twitter)};
          }
        `
      : null};
  ${(props) =>
    props.company === 'google'
      ? css`
          background-color: ${({ theme }) => theme.colors.box};
          &:hover {
            background-color: ${({ theme }) => darken(0.05, theme.colors.box)};
          }
        `
      : null};
  ${(props) =>
    props.company === 'apple'
      ? css`
          background-color: ${({ theme }) => theme.colors.apple};
          &:hover {
            background-color: ${({ theme }) =>
              darken(0.05, theme.colors.apple)};
          }
        `
      : null};

  .label {
    color: ${(props) =>
      props.company === 'google'
        ? css`
            ${({ theme }) => theme.colors.black}
          `
        : css`
            ${({ theme }) => theme.colors.white}
          `};
  }
`;
